import Epar from './Epar';
import Registration from './Registration';

export interface RawRegistration {
	epar: {
		id: string;
		category: string;
		medicineName: string;
		previousMedicineName: string | null;
		therapeuticAreas: string[];
		internationalNonProprietaryNameOrCommonName: string;
		activeSubstance: string;
		productNumber: string;
		patientSafety: boolean;
		authorisationStatus: string;
		atcCode: string;
		additionalMonitoring: boolean;
		generic: boolean;
		biosimilar: boolean;
		conditionalApproval: boolean;
		exceptionalCircumstances: boolean;
		acceleratedAssessment: boolean;
		orphanMedicine: boolean;
		marketingAuthorisationDate: string | null;
		dateOfRefusalOfMarketingAuthorisation: string | null;
		marketingAuthorisationHolderOrCompanyName: string;
		humanPharmacotherapeuticGroup: string;
		dateOfOpinion: string | null;
		decisionDate: string | null;
		revisionNumber: number;
		conditionOrIndication: string;
		firstPublished: string;
		revisionDate: string | null;
		url: string;
	} | null;
}

export default function mapRegistration(registration: RawRegistration): Registration {
	const { epar } = registration;

	return new Registration(
		epar
			? new Epar(
					epar.id,
					epar.category,
					epar.medicineName,
					epar.previousMedicineName,
					epar.therapeuticAreas,
					epar.internationalNonProprietaryNameOrCommonName,
					epar.activeSubstance,
					epar.productNumber,
					epar.patientSafety,
					epar.authorisationStatus,
					epar.atcCode,
					epar.additionalMonitoring,
					epar.generic,
					epar.biosimilar,
					epar.conditionalApproval,
					epar.exceptionalCircumstances,
					epar.acceleratedAssessment,
					epar.orphanMedicine,
					epar.marketingAuthorisationDate !== null ? new Date(epar.marketingAuthorisationDate) : null,
					epar.dateOfRefusalOfMarketingAuthorisation !== null
						? new Date(epar.dateOfRefusalOfMarketingAuthorisation)
						: null,
					epar.marketingAuthorisationHolderOrCompanyName,
					epar.humanPharmacotherapeuticGroup,
					epar.dateOfOpinion !== null ? new Date(epar.dateOfOpinion) : null,
					epar.decisionDate !== null ? new Date(epar.decisionDate) : null,
					epar.revisionNumber,
					epar.conditionOrIndication,
					new Date(epar.firstPublished),
					epar.revisionDate !== null ? new Date(epar.revisionDate) : null,
					epar.url
			  )
			: null
	);
}
